import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Partnership: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Partnership Opportunities
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Strategic Partnerships
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards is always looking for strategic partners who share our vision of helping consumers save money. Whether you're a brand, retailer, or service provider, we'd
						love to explore partnership opportunities.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Partnership Types
					</Text>
					<Spacer size={15} />
					<PartnershipType>
						<Text weight="bold" size={18}>
							Merchant Partnerships
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							Offer exclusive discounts to our members and reach thousands of engaged customers.
						</Text>
					</PartnershipType>
					<Spacer size={20} />
					<PartnershipType>
						<Text weight="bold" size={18}>
							Brand Collaborations
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							Co-market with Live Rewards to increase brand awareness and customer loyalty.
						</Text>
					</PartnershipType>
					<Spacer size={20} />
					<PartnershipType>
						<Text weight="bold" size={18}>
							Technology Integrations
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							Integrate with our platform to provide seamless experiences for our members.
						</Text>
					</PartnershipType>
					<Spacer size={20} />
					<PartnershipType>
						<Text weight="bold" size={18}>
							Affiliate Programs
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={16}>
							Earn commissions by referring new members to Live Rewards.
						</Text>
					</PartnershipType>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Why Partner with Us?
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						• Growing member base across the nation
						<br />
						• Proven track record of successful partnerships
						<br />
						• Dedicated partnership support team
						<br />
						• Flexible terms and conditions
						<br />• Mutual growth and success
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Let's Talk
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Interested in partnering with Live Rewards? We'd love to hear from you!
						<br />
						<br />
						<strong>Email:</strong> partnerships@liverewardsgo.com
						<br />
						<strong>Phone:</strong> 1-800-REWARDS
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;

const PartnershipType = styled.div`
	padding: 20px;
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	background-color: #fafafa;
`;
